// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("@rescript/std/lib/js/curry.js");

function trackUserAction(tracker, $$event) {
  Curry._1(tracker, $$event);
}

function trackPageView(tracker, page) {
  Curry._1(tracker, page);
}

var Amplitude = {
  trackUserAction: trackUserAction,
  trackPageView: trackPageView
};

exports.Amplitude = Amplitude;
/* No side effect */
